// extracted by mini-css-extract-plugin
export default {"plotterChart":"VerticalBarDiagram_plotterChart__01PUe"};